const PlayerCombinationStacking = {
    PLAYER_COMBINATION_STACKING_SET_IS_USED: 'PLAYER_COMBINATION_STACKING_SET_IS_USED',
    PLAYER_COMBINATION_STACKING_ADD_ITEM: 'PLAYER_COMBINATION_STACKING_ADD_ITEM',
    PLAYER_COMBINATION_STACKING_REMOVE_ITEM: 'PLAYER_COMBINATION_STACKING_REMOVE_ITEM',
    PLAYER_COMBINATION_STACKING_SET_DATA_FROM_STORAGE: 'PLAYER_COMBINATION_STACKING_SET_DATA_FROM_STORAGE',
};

export default PlayerCombinationStacking;
